import React from 'react';

const PubNubCtx = React.createContext();

export const { Provider } = PubNubCtx;

// eslint-disable-next-line react/display-name
export const withPubNubCtx = WrappedComponent => props =>
  (
    <PubNubCtx.Consumer>
      {({ subscribe, unsubscribe }) => {
        if (subscribe === undefined || unsubscribe === undefined) {
          /* eslint-disable-next-line no-console */
          console.warn('[withPubNubCtx] You are not using a PubNubProvider.');
        }
        return <WrappedComponent {...props} subscribe={subscribe} unsubscribe={unsubscribe} />;
      }}
    </PubNubCtx.Consumer>
  );
